import React from 'react';

import FeedbackCard from '../ui/FeedbackCard';

const FeedbackPage: React.FC = () => {
  return (
    <div className="feedback-page wrapper wrapper--main">
      <FeedbackCard variant="page" />
    </div>
  );
};

export default FeedbackPage;

